import {useLayout} from '../../Providers/LayoutProvider';
import Button from '../Buttons/Button';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faBars} from '@fortawesome/pro-solid-svg-icons/faBars';
import {ButtonSize} from '../../Data/Enums/Generic';
import {ColourMod} from '../../Data/Enums/LayoutEnums';
import {FC} from 'react';

interface iMenuToggle {
	customColour?: ColourMod | null;
	size?: ButtonSize;
}

const MenuToggle: FC<iMenuToggle> = (props) => {
	const { sidebarOpen, toggleSidebar } = useLayout();

	return (
		<Button
			raised={true}
			icon={<FontAwesomeIcon icon={faBars} fixedWidth={true} size={"xs"}/>}
			iconOnly={true}
			size={props.size ?? ButtonSize.Small}
			onClick={() => toggleSidebar()}
			title={`${sidebarOpen ? 'Shrink' : 'Expand'} Menu`}
			colour={props.customColour ? props.customColour : ColourMod.Text}
		 >
			<span className={'logo-emblem'} />
		</Button>
	)
}

export default MenuToggle